module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-section', {
    attrs: {
      "showBack": _vm.showBack
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c60684ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 51
// module chunks = 0